/* pantallas-alumno (B): LOS COLORES DE LAS PANTALLAS DEL ALUMNO, EN UN SOLO LUGAR.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Son los del documento del Panel (seccion "Colores, tipografia y medidas") con lo que quedo en
   produccion (anexo, parte A: el fondo de la pagina es #0E0E0E) y los de las "Piezas nuevas" de las
   dos partes del alumno. Lo que el Panel ya exporta se re-exporta de su archivo, no se copia. Los
   colores van en linea (style) o en clases escritas enteras dentro de cada pieza: Tailwind solo genera
   lo que ve escrito completo, asi que estas constantes son para `style`, no para armar clases. */
export { TONOS_DEL_CHIP } from '../panel/ChipDeEstado';
export { TONOS_DEL_AVISO } from '../panel/AvisoDelPanel';

export const COLORES = Object.freeze({
  fondoPagina: '#0E0E0E',
  tarjeta: '#141414',
  bordeTarjeta: '#222222',
  tarjetaInterna: '#101010',
  bordeInterna: '#1F1F1F',
  campo: '#0E0E0E',
  bordeCampo: '#262626',
  secundario: '#1B1B1B',
  bordeSecundario: '#2C2C2C',
  naranja: '#F27A2E',
  textoSobreNaranja: '#160A02',
  naranjaTexto: '#F7A06A',
  naranjaIcono: '#1C130D',
  elegidoFondo: '#17100B',
  textoPrincipal: '#F4F4F3',
  textoSecundario: '#9A9A9A',
  textoMenu: '#C8C8C8',
  verde: '#4ADE80',
  rojo: '#F87171',
  rojoBorrar: '#DC2626',
  pista: '#262626',
});

// Los recuadros suaves de las dos partes (avisos, lo que falta, confirmar).
export const TONO_NARANJA_SUAVE = Object.freeze({ fondo: '#1A120C', borde: '#3A2414' });
export const TONO_ROJO_SUAVE = Object.freeze({ fondo: '#1C1010', borde: '#3D1C1C' });

// Apagado: 45 % los botones y controles; 38 % las opciones de un menu (el del Panel y el del avatar).
export const OPACIDAD_APAGADO = 0.45;
export const OPACIDAD_MENU_APAGADO = 0.38;
// Apagado SIN RED (seccion 4.1 del encargo): todo control que la app sin red apaga va al 38 %, el
// mismo valor que el Panel (`OPACIDAD_SIN_RED` de su menu de tres puntos). El 45 se queda para los
// apagados por otro motivo.
export const OPACIDAD_SIN_RED = 0.38;
